import { JoinWaitlistModal } from "components/website/modal-variants";
import { createContext, useContext, useState, useCallback, type ReactNode } from "react";

interface WaitlistModalContextType {
  openWaitlistModal: () => void;
  closeWaitlistModal: () => void;
  isWaitlistModalOpen: boolean;
}

const WaitlistModalContext = createContext<WaitlistModalContextType | undefined>(undefined);

interface WaitlistModalProviderProps {
  children: ReactNode;
}

export const WaitlistModalProvider = ({ children }: WaitlistModalProviderProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const openWaitlistModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeWaitlistModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <WaitlistModalContext.Provider
      value={{
        openWaitlistModal,
        closeWaitlistModal,
        isWaitlistModalOpen: isOpen,
      }}
    >
      {children}
      <JoinWaitlistModal show={isOpen} onClose={closeWaitlistModal} />
    </WaitlistModalContext.Provider>
  );
};

export const useWaitlistModal = (): WaitlistModalContextType => {
  const context = useContext(WaitlistModalContext);
  if (!context) {
    throw new Error("useWaitlistModal must be used within a WaitlistModalProvider");
  }
  return context;
};
